import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AppLogService } from '@bayclubs/logging';
import { environment } from 'src/environments/environment';
import { IdentityProvider } from '@bayclubs/utils';

@Injectable({
    providedIn: 'root'
})
export class RedirectToHomeUrlGuard implements CanActivate {
    constructor(private logger: AppLogService) {}

    canActivate() {
        const referrer = document.referrer || 'none';
        this.logger.warn(
            `404 redirect: unmatched route '${window.location.href}' (referrer: ${referrer}), redirecting to ${environment.homePageUrl}`,
            IdentityProvider.emptyIdentity
        );
        window.location.href = environment.homePageUrl;
        return false;
    }
}
